import chatIdentifiers from '@/helpers/chatIdentifiers'
import HttpService from '@/services/HttpService'
import axios from 'axios'

export default class BaseModel extends HttpService {
  constructor() {
    // * AXIOS OPTIONS
    const axiosOptions = {
      baseURL:
        process.env.NODE_ENV === 'development' ? '/' : chatIdentifiers.url,
      debug: process.env.NODE_ENV === 'development',
    }

    // * CREATE AXIOS INSTANCE
    const axiosIntance = axios.create(axiosOptions)

    // * Add a request interceptor to pass tenantSid and configSid to all request
    axiosIntance.interceptors.request.use((config) => {
      config.headers = {
        ...config.headers,
        tenantSid: chatIdentifiers.tenantSid,
        configSid: chatIdentifiers.configSid,
      }
      return config
    })

    super({
      _$http: axiosIntance,
      _service: 'publicapi',
    })
  }
}
